<!--{{results$ | async | json}}-->

<ng-container *ngIf="_result | async as result; else loading;">
  <!--{{options.thresholds | json}}-->
  <ngx-gauge [size]="size | async"
             [type]="options?.gaugeType ?? gaugeType"
             [value]="result?.value ?? 0"
             [label]="options?.gaugeLabel ?? gaugeLabel"
             [append]="options?.gaugeAppendText ?? gaugeAppendText"
             [thresholds]="options?.thresholds ?? thresholds_Default"
             [markers]="markerConfig"
             [thick]="options?.thickness ?? thickness"
             [duration]="options?.animationDuration ?? animationDuration"
             [min]="_min | async"
             [max]="_max | async"
             [cap]="options?.cap ?? cap"
             margin="15"
             (click)="onClick(result)">
  </ngx-gauge>


</ng-container>
<ng-template #loading>
  <span class="fa fa-spinner fa-pulse fa-5x" style="opacity: 1; color:gray;"></span>
</ng-template>
